"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { headerNavigation } from "@/lib/navigation";

type MobileNavigationProps = {
  open: boolean;
  onNavigate: () => void;
};

export function MobileNavigation({ open, onNavigate }: MobileNavigationProps) {
  const pathname = usePathname();

  if (!open) {
    return null;
  }

  return (
    <div className="md:hidden border-t" style={{ borderColor: "var(--border-soft)" }}>
      <nav className="container-shell py-4 flex flex-col gap-2">
        {headerNavigation.map((item) => {
          const active = pathname === item.href;
          return (
            <Link
              key={item.href}
              href={item.href}
              onClick={onNavigate}
              className="rounded-xl px-4 py-3 text-sm font-semibold transition-colors"
              style={{
                color: active ? "#ffffff" : "var(--text-secondary)",
                background: active ? "var(--brand-600)" : "var(--bg-surface)",
                border: `1px solid ${active ? "var(--brand-600)" : "var(--border-soft)"}`,
              }}
            >
              {item.label}
            </Link>
          );
        })}
      </nav>
    </div>
  );
}
